import { createMemo } from "solid-js"
import { EngineMode } from "../../lib/core/engine/EngineMode/EngineMode.enum"
import { useEngineModeSignal } from "../signal/useEngineModeSignal"
import createSharedCachedFactory from "./createSharedCachedFactory"

export const useIsEngineActiveMemo = createSharedCachedFactory((engine) => {
  const [getEngineMode] = useEngineModeSignal(engine)

  const memo = createMemo(() => {
    return getEngineMode() !== EngineMode.None
  })

  return memo
})
